module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_11_47_419Z.6f9a33a9.png";